import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "my-10 grid grid-cols-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "box col-span-12 rounded-xl p-5 md:col-span-8 md:col-start-3" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-thin leading-10 text-gray-500 dark:text-gray-300" }, [
      /*#__PURE__*/_createTextVNode(" Hieronder een overzicht van de gasvooraard voor "),
      /*#__PURE__*/_createElementVNode("strong", null, "verschillende locaties"),
      /*#__PURE__*/_createTextVNode(" in Nederland. De grootste voorraden zijn te vinden in "),
      /*#__PURE__*/_createElementVNode("strong", null, "Norg en Bergermeer"),
      /*#__PURE__*/_createTextVNode(". ")
    ])
  ])
], -1)
const _hoisted_2 = {
  key: 0,
  class: "flex w-full flex-row items-center justify-center text-center"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "storage-list grid grid-cols-12 py-10" }
const _hoisted_5 = { class: "storage-item min-h-24 lg:px-10" }
const _hoisted_6 = {
  key: 0,
  class: "mt-5 text-center"
}
const _hoisted_7 = {
  key: 1,
  class: "flex flex-col items-center"
}
const _hoisted_8 = { class: "box mb-10 w-full rounded-2xl" }
const _hoisted_9 = { class: "p-5" }
const _hoisted_10 = { class: "border-1 my-8 grid w-full grid-cols-12 border-y border-dashed p-5 text-gray-500 dark:border-gray-700" }
const _hoisted_11 = { class: "col-span-4 flex justify-center" }
const _hoisted_12 = { class: "mb-2 text-center font-semibold dark:text-gray-400" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-light text-gray-400" }, "TWh", -1)
const _hoisted_15 = { class: "col-span-4 flex justify-center" }
const _hoisted_16 = { class: "text-center font-semibold dark:text-gray-400" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-light text-gray-400" }, "GWh/d", -1)
const _hoisted_19 = { class: "col-span-4 flex justify-center" }
const _hoisted_20 = { class: "text-center font-semibold dark:text-gray-400" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-light text-gray-400" }, "GWh/d", -1)
const _hoisted_23 = { class: "box mb-5 w-full rounded-2xl p-5" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-6 text-center text-xl font-semibold text-gray-500 dark:text-white" }, "Geschiedenis", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("small", { class: "w-full pr-10 text-right text-xs text-gray-300 dark:text-gray-600" }, "Data from GIE AGSI / ALSI ", -1)
const _hoisted_26 = {
  key: 2,
  class: "flex h-full items-center justify-center"
}

import { onMounted, Ref, ref } from 'vue';
import LineChart from '@/components/charts/LineChart.vue';
import SectionTitle from '@/components/ui/SectionTitle.vue';
import DoughtnutChart from '@/components/charts/DoughtnutChart.vue';
import AppDivider from '@/components/ui/AppDivider.vue';
import AppLoader from '@/components/ui/AppLoader.vue';
import { useStorageStore, StorageResponse } from '@/stores/main';
import IntroductionSection from '@/components/ui/IntroductionSection.vue';
import { colorScheme, storageDataIDs } from '../../constants/constants';
import GasStorageCountry from './GasStorageCountry.vue';
import AppErrorMessage from '../ui/AppErrorMessage.vue';

const STORAGE_TYPE = 'location';

export default /*#__PURE__*/_defineComponent({
  __name: 'GasStorage',
  setup(__props) {

const store = useStorageStore();
const storageLocations: { [type: string]: any } = ref({});
const colorPallete: Ref<string[]> = ref(['blue', 'orange', 'green', 'purple', 'yellow', 'pink']);
const gasStorageForPie: Ref<any[]> = ref([]);
const globalError: Ref<boolean> = ref(false);

const getStorageData = async () => {
  const URL = '/.netlify/functions/getGasStorage';
  let data: StorageResponse;

  const header = new Date().getTime();

  try {
    if (!store.hasValidStorageData(STORAGE_TYPE)) {
      const res = await fetch(URL, { headers: { 'x-time': header } });
      data = await res.json();

      store.addstorageItem({ ...data, type: STORAGE_TYPE, timestamp: Date.now() });
    } else {
      data = store.getStorageItem(STORAGE_TYPE) as StorageResponse;
    }
  } catch (err) {
    data = {} as StorageResponse;
  }

  return data;
}

const setAndFormatData = (data: any) => {
  const storageData = data.data;

  // set full property
  storageData.full = Math.round(storageData.data[0].full);

  // get latest history item
  const lastItem = storageData.data[0];
  storageData.storage = {
    storage: lastItem.gasInStorage,
    withdrawal: lastItem.withdrawal,
    injection: lastItem.injection
  }

  // setup pie chart data
  const colors = Object.values(colorScheme);

  const pieStorageData = {
    name: storageData.name,
    y: parseInt(storageData.storage.storage, 10),
    color: colors[gasStorageForPie.value?.length]
  }

  gasStorageForPie.value.push(pieStorageData);

  storageData.history = [{
    data: storageData.data.map((item: any) => {
      return {
        x: new Date(item.gasDayStart),
        y: +item.full
      }
    })
  }];

  setTimeout(() => {
    storageLocations.value[storageData.id] = storageData;
  }, 500);
}

/**
 * on mounted Vue lifecycle event
 */
onMounted(async () => {
  const data: any = await getStorageData();

  if (!data.result) {
    return;
  }

  if (!data.result?.length) {
    globalError.value = true;
  }

  data.result.forEach((item: any) => {
    setAndFormatData(item);
  })
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(IntroductionSection),
    _createVNode(SectionTitle, {
      class: "mb-20",
      title: "Gas Voorraad"
    }),
    _createVNode(GasStorageCountry, { pieChartData: gasStorageForPie.value }, null, 8, ["pieChartData"]),
    _createVNode(AppDivider),
    _createVNode(SectionTitle, {
      id: "voorraad",
      class: "mb-20",
      title: "Gas Voorraad",
      subTitle: "per locatie"
    }),
    _hoisted_1,
    (globalError.value)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createVNode(AppErrorMessage)
        ]))
      : _createCommentVNode("", true),
    (!globalError.value)
      ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(storageDataIDs), (id, index) => {
              return (_openBlock(), _createElementBlock("section", {
                class: "col-span-12 border-dashed pb-10 dark:border-gray-700 lg:col-span-4 lg:border-r",
                key: index
              }, [
                _createElementVNode("div", _hoisted_5, [
                  (storageLocations.value[id]?.error)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
                        _createVNode(AppErrorMessage)
                      ]))
                    : _createCommentVNode("", true),
                  (!storageLocations.value[id]?.error && storageLocations.value[id]?.name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createVNode(DoughtnutChart, {
                              title: storageLocations.value[id]?.name,
                              city: storageLocations.value[id]?.city,
                              value: storageLocations.value[id]?.full,
                              color: colorPallete.value[index]
                            }, null, 8, ["title", "city", "value", "color"])
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("p", _hoisted_12, [
                                _createTextVNode("Totaal voorraad"),
                                _hoisted_13,
                                _createElementVNode("span", {
                                  class: _normalizeClass(["text-2xl font-medium", ['text-' + colorPallete.value[index]]])
                                }, [
                                  _createTextVNode(_toDisplayString(storageLocations.value[id]?.storage.storage) + " ", 1),
                                  _hoisted_14
                                ], 2)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("p", _hoisted_16, [
                                _createTextVNode("Toegevoegd "),
                                _hoisted_17,
                                _createElementVNode("span", {
                                  class: _normalizeClass(["text-2xl font-medium", ['text-' + colorPallete.value[index]]])
                                }, [
                                  _createTextVNode(_toDisplayString(storageLocations.value[id]?.storage.injection) + " ", 1),
                                  _hoisted_18
                                ], 2)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("p", _hoisted_20, [
                                _createTextVNode("Uitgehaald "),
                                _hoisted_21,
                                _createElementVNode("span", {
                                  class: _normalizeClass(["text-2xl font-medium", ['text-' + colorPallete.value[index]]])
                                }, [
                                  _createTextVNode(_toDisplayString(storageLocations.value[id]?.storage.withdrawal) + " ", 1),
                                  _hoisted_22
                                ], 2)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _hoisted_24,
                          _createVNode(LineChart, {
                            class: "-ml-2",
                            chartData: storageLocations.value[id]?.history,
                            height: 260,
                            yAxisTitle: '% vol',
                            color: colorPallete.value[index],
                            subTitle: 'Geschiedenis van de laatste 6 maanden'
                          }, null, 8, ["chartData", "color"])
                        ]),
                        _hoisted_25
                      ]))
                    : _createCommentVNode("", true),
                  (!storageLocations.value[id]?.error && !storageLocations.value[id]?.name)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createVNode(AppLoader, { type: "small" })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(AppDivider, { type: "small" })
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})